module.exports = __webpack_public_path__ + "static/media/shop.8d7b56db.jpg";